module.exports = __webpack_public_path__ + "static/media/logo3.2b1087f6.png";